import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'


export default function SelectCityTo({ ...props }) {

    const myProps = {
        urlAjax: FORM_URL.PACKAGES_CITY,
        placeholder: 'Select city to',
        icon: { icon: 'city' },
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}